import { Check } from "lucide-react";

/**
 * MultiSelectInput — multi tap-target chips.
 * Pure renderer; value is an array of keys.
 */
export default function MultiSelectInput({ question, value, onChange }) {
  const selectedSet = new Set(Array.isArray(value) ? value : []);

  const toggle = (key) => {
    const next = new Set(selectedSet);
    if (next.has(key)) next.delete(key);
    else next.add(key);
    onChange(Array.from(next));
  };

  return (
    <div className="space-y-3" data-testid={`q-${question.id}-options`}>
      {question.helper && (
        <p className="text-xs text-slate-500">{question.helper}</p>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {question.options?.map((opt) => {
          const selected = selectedSet.has(opt.key);
          return (
            <button
              type="button"
              key={opt.key}
              onClick={() => toggle(opt.key)}
              data-testid={`q-${question.id}-opt-${opt.key}`}
              className={`kcis-option w-full text-left px-5 py-4 flex items-start gap-3 ${
                selected ? "kcis-option--selected" : ""
              }`}
              aria-pressed={selected}
            >
              <span
                aria-hidden
                className={`mt-0.5 shrink-0 rounded-md border h-5 w-5 flex items-center justify-center transition ${
                  selected ? "bg-purple-900 border-purple-900 text-white" : "border-slate-300"
                }`}
              >
                {selected && <Check className="h-3 w-3" />}
              </span>
              <span className="text-base text-slate-800 leading-relaxed">{opt.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
